import React, { useContext } from 'react';

import BuildingSummaryContainer from '@totem/components/portfolio/buildings/list/buildingSummary/BuildingSummaryContainer';
import BuildingSummaryTable from '@totem/components/portfolio/buildings/list/buildingSummary/BuildingSummaryTable';
import RegionDetailsContext from '@totem/components/portfolio/regions/details/RegionDetailsContext';
import RegionDetailsKPIs from '@totem/components/portfolio/regions/details/RegionDetailsKPIs';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

const RegionDetailsLayout = () => {
  const { id } = useContext(RegionDetailsContext);

  return (
    <>
      <IBCard isCovered>
        <RegionDetailsKPIs />
      </IBCard>
      <br />
      <IBCard isCovered title="Buildings">
        <BuildingSummaryContainer
          defaultFilters={{ regionId: [id] }}
          staticFilters={{ regionId: [id] }}
        >
          <BuildingSummaryTable />
        </BuildingSummaryContainer>
      </IBCard>
    </>
  );
};

export default RegionDetailsLayout;
